import { render, staticRenderFns } from "./DetailWorkDialog.vue?vue&type=template&id=e5dcc970&"
import script from "./DetailWorkDialog.vue?vue&type=script&lang=js&"
export * from "./DetailWorkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports